export default __webpack_public_path__ + "static/home-recipe-example-2-bb9f9f23483d5f8b527f3d8fdb180dc2.jpg";